module.exports = __webpack_public_path__ + "img/defkf4.8b2d0b35.png";